import {
  type OnboardingState,
  type OnboardingStep,
} from "@dashboard/welcomePage/WelcomePageOnboarding/onboardingContext/types";

// Saleor configuration order: cities → warehouses → shipping → taxes →
// catalog structure → products → team. Each step depends on the prior ones.
export const initialOnboardingSteps: OnboardingStep[] = [
  {
    id: "create-cluster",
    completed: false,
    expanded: undefined,
  },
  {
    id: "add-warehouse",
    completed: false,
    expanded: undefined,
  },
  {
    id: "shipping-zone",
    completed: false,
    expanded: undefined,
  },
  {
    id: "configure-taxes",
    completed: false,
    expanded: undefined,
  },
  {
    id: "add-categories",
    completed: false,
    expanded: undefined,
  },
  {
    id: "add-attributes",
    completed: false,
    expanded: undefined,
  },
  {
    id: "add-product-type",
    completed: false,
    expanded: undefined,
  },
  {
    id: "create-product",
    completed: false,
    expanded: undefined,
  },
  {
    id: "invite-staff",
    completed: false,
    expanded: undefined,
  },
];

export const TOTAL_STEPS_COUNT = initialOnboardingSteps.length;

export const getInitialOnboardingState = (isNewUser: boolean): OnboardingState => {
  if (isNewUser) {
    return {
      onboardingExpanded: true,
      stepsCompleted: [],
      stepsExpanded: {} as OnboardingState["stepsExpanded"],
    };
  }

  return {
    onboardingExpanded: false,
    stepsCompleted: initialOnboardingSteps.map(step => step.id),
    stepsExpanded: {} as OnboardingState["stepsExpanded"],
  };
};
